<template>
    <v-card>
        <v-card-title>
            Add Participant
        </v-card-title>
        <v-card-text v-if="pin===false">
            <v-text-field
                    outlined
                    label="First Name"
                    v-model="athlete.firstname"
            ></v-text-field>
            <v-text-field
                    outlined
                    label="Last Name"
                    v-model="athlete.lastname"
            ></v-text-field>
            <v-text-field
                    outlined
                    label="Email"
                    v-model="athlete.email"
            ></v-text-field>
            <v-text-field
                    outlined
                    label="Cell"
                    v-model="athlete.cell"
            ></v-text-field>
            Or <a  class="indigo--darken-2--text subheading font-weight-medium" @click="pin=' '">Add by PIN</a>
            <InfoButton info="help.pininfo" />
        </v-card-text>
        <v-card-text v-else>
            <p class="subheading font-weight-light">
                <InfoButton info="help.pininfo" />
                If you are registering a partner, player, friends child, etc.
                created under another account, get their pin from the owners
                account -> myplayers, and enter it here. It will auto populate, and be much much cooler...
            </p>
            <v-text-field
                    outlined
                    label="PIN"
                    mask="NNNN"
                    v-model="pin"
                    @keyup="getAthleteByPin()"
            ></v-text-field>
            <v-list>
                <v-list-tile :key="newathlete.partkey" v-if="newathlete">
                    <v-list-tile-avatar>
                        <img :src="newathlete.profilepic" />
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                        <v-list-tile-title>{{newathlete.firstname}} {{newathlete.lastname}}</v-list-tile-title>
                        <v-list-tile-sub-title>PIN: {{newathlete.pin}}</v-list-tile-sub-title>
                    </v-list-tile-content>
                    <v-list-tile-action @click="newAthleteFromPin()">
                        <v-checkbox></v-checkbox>
                    </v-list-tile-action>
                </v-list-tile>
            </v-list>
            or <a  class="indigo--darken-2--text subheading font-weight-medium" @click="pin=false">Add by Name</a>
        </v-card-text>
        <v-card-actions>
            <v-btn color="indigo darken-2" class="white--text" @click="reset()">Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="indigo darken-2" class="white--text" @click="newAthlete()" :loading="saving">Save</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import {
      mapActions,
      mapState
    } from 'vuex'
    import InfoButton from "@/components/InfoButton";
    export default {
      name: "NewAthlete",
      components: {InfoButton},
      data() {
            return {
              saving:false,
              newathlete:false,
              pin:false
            }
        },
        computed:{
            ...mapState(['sportcode']),
          athlete(){
              return {
                firstname:undefined,
                lastname:undefined,
                email:undefined,
                birthday:undefined,
                cell:undefined,
                sportcode:this.sportcode
              }
          }
        },
        mounted() {
        },
        methods: {
          ...mapActions(['post',  'get', 'delete', 'put']),
            async newAthlete(){
                let em = this;
                //em.saving=true;
                let a = await this.post({path:'api/register/newathlete',body:this.athlete})
                a = em.$store.state.myathletes;
                a.push(response);
                this.$store.commit('setAthletes',a)
                setTimeout(function(){
                  em.saving=false
                  em.reset();
                },1100)
            },
            getAthleteByPin(){
                let em = this;
                if(em.pin.length!==4)return;
                //em.saving=true;
                let headers = {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Pool':this.pool,
                    'Authorization':'Bearer ' + this.token,
                    'Activeclub': em.$store.state.orgkey
                };
                let args = {
                    headers:headers,
                    method:'GET'
                };
                fetch(this.$store.state.url+'api/register/newathlete/'+em.pin,args)
                    .then((response) => response.json())
                    .then((response) => {
                        em.newathlete=response
                    })
            },
            newAthleteFromPin(){
                let em = this;
                em.saving=true;
                let headers = {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Pool':this.pool,
                    'Authorization':'Bearer ' + this.token,
                    'Activeclub': em.$store.state.orgkey
                };
                let args = {
                    headers:headers,
                    method:'POST',
                    body:JSON.stringify(em.newathlete)
                };
                fetch(this.$store.state.url+'api/register/newathletefrompin',args)
                    .then((response) => response.json())
                    .then((response) => {
                        console.log("New Athlete: ", response)
                        let a = em.$store.state.myathletes;
                        a.push(response);
                        em.$store.commit('setAthletes',a)
                        setTimeout(function(){
                            em.saving=false
                            em.reset();
                        },1100)

                    })
            },
            reset() {
                //coses the dialog
                this.firstname=undefined;
                this.lastname=undefined;
                this.email=undefined;
                this.birthday=undefined;
                this.cell=undefined;
                this.pin=false;
                this.newathlete=false;
                this.$emit('close')
            }
        }
    }
</script>

<style scoped>

</style>